import React, { useEffect, useState } from 'react';
import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, BarChart3, FilePen, Sparkles, Settings, LogOut } from 'lucide-react';
import { clearToken, adminApi } from './api';
import { useAdminMeta } from './useAdminMeta';
import AnyaPanel from './AnyaPanel';
import './admin.css';

const sections = [
  { to: '/admin', icon: LayoutDashboard, label: 'Главная', end: true, enabled: true, testid: 'rail-main' },
  { to: '/admin/numbers', icon: BarChart3, label: 'Цифры', enabled: true, testid: 'rail-numbers' },
  { to: '/admin/content', icon: FilePen, label: 'Содержимое сайта', enabled: true, testid: 'rail-content' },
  { to: '/admin/knowledge', icon: Sparkles, label: 'База знаний', enabled: true, testid: 'rail-knowledge' },
  { to: '/admin/settings', icon: Settings, label: 'Настройки', enabled: true, testid: 'rail-settings' },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [todayCount, setTodayCount] = useState(0);

  // noindex и название вкладки для админских страниц
  const pathTitle = {
    '/admin': 'Главная',
    '/admin/numbers': 'Цифры',
    '/admin/content': 'Содержимое сайта',
    '/admin/knowledge': 'База знаний',
    '/admin/settings': 'Настройки',
  }[location.pathname] || 'Кабинет';
  useAdminMeta(pathTitle);

  // Тихий поллинг количества событий сегодня — для бейджа в сайдбаре
  useEffect(() => {
    let stopped = false;
    const tick = async () => {
      try {
        const d = await adminApi.today();
        if (!stopped) setTodayCount(d?.counts?.new_contacts || 0);
      } catch {/* ignore */}
    };
    tick();
    const id = setInterval(tick, 60_000);
    return () => { stopped = true; clearInterval(id); };
  }, [location.pathname]);

  const onLogout = async () => {
    try { await adminApi.logout(); } catch {/* ignore */}
    clearToken();
    navigate('/admin/login', { replace: true });
  };

  return (
    <div className="admin-shell flex" data-testid="admin-root">
      <aside className="dark-rail" data-testid="admin-sidebar">
        <div className="rail-header">
          <div className="rail-avatar">С</div>
          <div className="rail-label">
            <div className="rail-name">Светлана</div>
            <div className="rail-sub">Психолог</div>
          </div>
        </div>

        <nav className="rail-nav">
          {sections.map((s) => (
            <NavLink
              key={s.to}
              to={s.to}
              end={s.end}
              data-testid={s.testid}
              className={({ isActive }) => `rail-item ${isActive ? 'active' : ''} ${!s.enabled ? 'disabled' : ''}`}
              title={s.label}
            >
              <s.icon className="icon" strokeWidth={1.6} />
              <span className="rail-label">{s.label}</span>
              {s.to === '/admin' && todayCount > 0 && (
                <span className="badge" data-testid="rail-today-badge">{todayCount}</span>
              )}
            </NavLink>
          ))}
        </nav>

        {/* Аня-Эксперт — встроенный чат в сайдбаре */}
        <AnyaPanel />

        <div className="rail-foot">
          <button
            onClick={onLogout}
            className="rail-item w-full"
            data-testid="admin-logout"
            style={{ background: 'transparent', border: 'none' }}
          >
            <LogOut className="icon" strokeWidth={1.6} />
            <span className="rail-label">Выйти</span>
          </button>
        </div>
      </aside>

      <main className="admin-work flex-1 min-w-0" data-testid="admin-main">
        <Outlet />
      </main>
    </div>
  );
}
